import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportSubmissions'
import context from '@/context'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { ReportSubmissionTable } from './reportSubmissionTable'
import ReportAttachments from '@/components/reporting/reportAttachments'
import ReportSubmissionComments from '@/components/reporting/reportSubmissionComments'
import ReportSubmissionDetailButtons from './reportSubmissionDetailButtons'
import LoadingIndicator from '@/components/LoadingIndicator'
import Name from '@/components/Name'
import { ReportSubmissionState } from '@/enums/ReportSubmissionState'
import { ReportSubmissionGroupState } from '@/enums/ReportSubmissionGroupState'
import getEnumTranslation from '@/enums/enums'
import { Col, Row } from 'reactstrap'
import { reportSubmissionsStatus, reportSubmissionGroupStatus } from '@/components/reporting/submissions/reportSubmissionsStatus'
import { ReportSubmissionTitle } from '@/components/reporting/submissions/reportSubmissionTitle'
import { Forecasting } from '@/components/reporting/forecasting'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { ReportSubmissionGroupNotes } from '@/components/reporting/reportSubmissionGroupNotes'
import { CheckingRulesList } from '@/components/reporting/submissions/checkingRulesList'
import { withPermissions } from '@/decorators/withPermissions'

@localized()
@withPermissions()
class ReportSubmissionDetail extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      id: props.match.params.id
    }

    this.getParentId = this.getParentId.bind(this)
    this.goBack = this.goBack.bind(this)
  }

  isGrantedToManage (forecasting) {
    return this.props.isGranted(forecasting ? 'CanManageForecast' : 'CanManageReports')
  }

  getSubmissionId () {
    return this.props.match.params.id
  }
  getParentId () {
    return this.props.match.params.parentId
  }
  getBackUrl (forecasting) {
    const url = forecasting ? 'forecast-report-submission-groups' : 'report-submission-groups'
    return `/${url}/${this.getParentId()}/report-submissions`
  }
  goBack (forecasting) {
    const url = this.getBackUrl(forecasting)
    this.props.history.push(url)
  }
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.getSubmissionId() !== prevProps.match.params.id) {
      this.reload()
    }
    if (this.props.pageKey !== prevProps.pageKey) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.getSubmissionId(), this.getParentId())
  }

  renderBody () {
    const { localize, reportSubmissions, reportSubmissionState, addAttachments } = this.props

    if (reportSubmissions.fetching === true) { return (<LoadingIndicator />) }
    const reportSubmission = reportSubmissions.reportSubmission || {}
    const reportSubmissionGroupState = reportSubmission.reportSubmissionGroupState
    const idle = reportSubmission.reportGroupProcessState === 0 || reportSubmission.reportGroupProcessState === 4
    const readonly = !(
      (reportSubmissionState === ReportSubmissionState.enum.Unbegun ||
      reportSubmissionState === ReportSubmissionState.enum.Unfinished ||
      reportSubmissionState === ReportSubmissionState.enum.Rejected ||
      reportSubmissionState === ReportSubmissionState.enum.Error) &&
      (reportSubmissionGroupState === ReportSubmissionGroupState.enum.Unbegun ||
      reportSubmissionGroupState === ReportSubmissionGroupState.enum.Incomplete ||
      reportSubmissionGroupState === ReportSubmissionGroupState.enum.Rejected) &&
      idle
    )
    const submissionId = this.getSubmissionId()
    return (
      <React.Fragment>
        <div className='r-s-d'>
          <WhiteBox>
            <Row>
              <Col sm='12'>
                <ReportSubmissionTable readonly={readonly || !this.isGrantedToManage(reportSubmission.forecasting)} />
              </Col>
            </Row>
            <Row className='mb-5 text-right'>
              <Col sm='12'>
                <ReportSubmissionDetailButtons
                  readonly={!this.isGrantedToManage(reportSubmission.forecasting)}
                  state={reportSubmissionState}
                  idle={idle}
                  localize={localize}
                  onEditClicked={() => this.props.updateState({ entityId: reportSubmission.id, state: ReportSubmissionState.enum.Unfinished })}
                  onFinishClicked={() => this.props.updateState({ entityId: reportSubmission.id, state: ReportSubmissionState.enum.Finished })}
                />
              </Col>
            </Row>
          </WhiteBox>
          <Row>
            <Col sm='12'>
              <ReportAttachments
                key={reportSubmissions.attachmentsKey}
                dataSource={() => context.api.reportSubmissionService.getAttachments(submissionId)}
                downloadAction={context.api.reportSubmissionService.download}
                parentId={submissionId}
                addAttachments={addAttachments}
                removeAttachment={id => this.props.removeAttachments({ entityId: submissionId, fileIds: [id] })}
                adding={reportSubmissions.adding} />
            </Col>
          </Row>
          <Row>
            <Col sm='12'><ReportSubmissionComments parentId={submissionId} /></Col>
          </Row>
        </div>
      </React.Fragment>
    )
  }
  renderGeneralBox (reportSubmissions, state, idle, groupState) {
    const reportSubmission = reportSubmissions.reportSubmission || {}
    const { localize } = this.props
    const submissionGroupName = {
      name: reportSubmission.reportSubmissionGroupName,
      latinName: reportSubmission.reportSubmissionGroupLatinName
    }

    const forecasting = reportSubmission.forecasting

    const status = getEnumTranslation({ localize, enumName: ReportSubmissionState.enumName, value: state })
    const groupStatus = getEnumTranslation({ localize, enumName: ReportSubmissionGroupState.enumName, value: groupState })
    return (
      <WhiteBox header='Reporting.General'>
        <Forecasting forecasting={forecasting} />
        <Row>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.Name' /></InfoLabel>
              <InfoContent><Name data={reportSubmission} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportTemplateName' /></InfoLabel>
              <InfoContent><Name data={reportSubmission.reportTemplateVersion} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportGroupSubmissionName' /></InfoLabel>
              <InfoContent><a className='link-regular' onClick={() => this.goBack(forecasting)}><Name data={submissionGroupName} /></a></InfoContent>
            </InfoRow>
          </Col>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.State' /></InfoLabel>
              <InfoContent className='border-less'>
                <span className={'status status--' + reportSubmissionsStatus(state)}>{status}</span>
                {!idle && <span className='ml-1 status status--warning'><Resx name='Common:Processing' /></span>}
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.GroupState' /></InfoLabel>
              <InfoContent className='border-less'>
                <span className={'status status--' + reportSubmissionGroupStatus(groupState)}>{groupStatus}</span>
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Common.Code' /></InfoLabel>
              <InfoContent>{reportSubmission.code}</InfoContent>
            </InfoRow>
          </Col>
        </Row>
      </WhiteBox>
    )
  }

  renderCheckingRules () {
    const { checkingRuleSubmissions } = this.props.reportSubmissions.reportSubmission

    if (!checkingRuleSubmissions || !checkingRuleSubmissions.length) return

    return <CheckingRulesList checkingRules={checkingRuleSubmissions} onlyShowIssues />
  }

  render () {
    const { reportSubmissions, reportSubmissionState } = this.props
    if (reportSubmissions.fetching === true) { return (<LoadingIndicator />) }
    const forecasting = (reportSubmissions.reportSubmission || {}).forecasting
    const groupState = (reportSubmissions.reportSubmission || {}).reportSubmissionGroupState
    const idle = (reportSubmissions.reportSubmission || {}).reportGroupProcessState === 0 ||
        (reportSubmissions.reportSubmission || {}).reportGroupProcessState === 4

    return <Main>
      <MainTop>
        <MainTopTitle backUrl={this.getBackUrl(forecasting)}>
          <Resx name='Reporting.ReportSubmissionDetailTitle' /> <ReportSubmissionTitle reportSubmission={this.props.reportSubmissions.reportSubmission} />
        </MainTopTitle>
      </MainTop>
      {this.renderGeneralBox(reportSubmissions, reportSubmissionState, idle, groupState)}
      {reportSubmissions.reportSubmission && this.renderCheckingRules()}
      <ReportSubmissionGroupNotes reportSubmission={reportSubmissions.reportSubmission || {}} />
      <MainBody transparent>
        {this.renderBody()}
      </MainBody>
    </Main>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportSubmissions: state.reportSubmissions,
    reportSubmissionState: state.reportSubmissions.reportSubmissionState,
    pageKey: state.reportSubmissionGroup.pageKey,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  addAttachments: actionCreators.addAttachments,
  removeAttachments: actionCreators.removeAttachments,
  updateState: actionCreators.updateState,
  clearReportData: actionCreators.clearReportData
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportSubmissionDetail)



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/detail/reportSubmissionDetail.js